import { ProductCategoriesControllerFindAll$Params } from '@klubovna/api-client';
import { ProductCategory } from '@klubovna/api-client';

export interface ProductCategoriesState {
  categories: ProductCategory[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  params: ProductCategoriesControllerFindAll$Params;
  loading: boolean;
  error: string | null;
}

export const initialProductCategoriesState: ProductCategoriesState = {
  categories: [],
  total: 0,
  page: 1,
  limit: 20,
  totalPages: 0,
  params: {
    page: 1,
    limit: 20,
    sortBy: 'sortOrder',
    sortOrder: 'ASC',
  },
  loading: false,
  error: null,
};
